import { render, staticRenderFns } from "./ActivityPromotionBanner.vue?vue&type=template&id=78859932&scoped=true"
import script from "./ActivityPromotionBanner.vue?vue&type=script&lang=js"
export * from "./ActivityPromotionBanner.vue?vue&type=script&lang=js"
import style0 from "./ActivityPromotionBanner.vue?vue&type=style&index=0&id=78859932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!D:\\Code\\ui\\comic_ai\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78859932",
  null
  
)

export default component.exports